import HTTPError from '../HTTPError';
class GatewayTimeout extends HTTPError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 504;
        super(status, ...args);
    }
}
export default GatewayTimeout;
